import React, { memo, Fragment } from "react";
import HTMLParser from "./htmlParser";
import blocks from "./blocks/index";
const Fallback = ({ outerHTML }) => {
    if ((outerHTML || "")
        .replace(/<([^>]+)>/gi, "")
        .replace(/\s+/g, " ")
        .trim().length === 0) {
        return React.createElement(React.Fragment, null);
    }
    return React.createElement(HTMLParser, null, outerHTML);
};
const LazyBlock = ({ block }) => {
    const [dir, blockname] = block.name.split("/");
    const Block = blocks[dir][blockname];
    return React.createElement(React.Fragment, null, Block ? React.createElement(Block, { ...block }) : React.createElement(Fallback, { ...block }));
};
const Parser = memo(({ structure }) => {
    if (!structure || !structure.length || typeof structure !== "object") {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(React.Fragment, null, structure.map((block, i) => {
        if (block === null || typeof block === "undefined") {
            return React.createElement(Fragment, { key: "null_" + i });
        }
        //~ if(!block.name) {
        if (!block.name) {
            //ce n'est pas une définition de bloc, mais déjà un composant;
            return React.createElement(Fragment, { key: "_" + i }, block);
        }
        return (React.createElement(LazyBlock, { key: block.name + "_" + i, block: block }));
    })));
});
export { LazyBlock };
export default Parser;
